import { findIndex } from "lodash";
import ORDER_MODES from "shared/constants/orderModes.const";
import IOrderMode from "shared/interfaces/OrderMode.interface";

/**
 * Return an order mode props based on it's id (value)
 * @param id
 * @returns
 */
export default (id: string): IOrderMode | null => {
  const modeIndex = findIndex(ORDER_MODES, (mode) => mode.id === id);
  if (~modeIndex) {
    return ORDER_MODES[modeIndex];
  }
  return null;
};
